import { render, staticRenderFns } from "./Comprehensive.vue?vue&type=template&id=558f30a0&scoped=true"
import script from "./Comprehensive.vue?vue&type=script&lang=js"
export * from "./Comprehensive.vue?vue&type=script&lang=js"
import style0 from "./Comprehensive.vue?vue&type=style&index=0&id=558f30a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f30a0",
  null
  
)

export default component.exports